var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 103,
    width: 413,
    height: 133,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.1,
    y: 103,
    width: 144.79,
    height: 133,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.19,160s27.6,26.67,28.84,40-19.23,24.19-13.33,28.53,22,15.82,15.81,25.74-9.3,12.41-7.13,14.58,7.44,4,7.13,9.3S288,288,288,288H190s-5.27.31-4.65-7.13,11.16-11.47,9.3-17.06-15.51-9.92-15.51-21.09,16.13-15.81,18.61-21.08-8.06-8.69-10.23-15.51,9-18.61,15.81-24.81,34.12-24.19,45-24.81S263.19,160,263.19,160Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290,373.71c-4.58-3.57-10.53-9.44-13.38-17.44-4.43-12.41-7.69-79-8.37-94-2.37-.72-4.75-1.44-7.09-2.13l1,62.63h-44.5l-3.89-62.31c-2.37.73-4.76,1.48-7.1,2.22.05,12.65.05,71.66-3.51,88.59-2.73,13-14.1,21.77-21,26a181.75,181.75,0,0,1-9.47,39.47h127.5A147.14,147.14,0,0,1,290,373.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.06,204s48.69-20.16,60.48-29.47,14.88-27.29-12.72-26.36-56.75,33.19-59.23,48.07S194,208,194,208",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.11,35.89S259.66,14.26,187.13,58,77.62,183.33,45.89,248.78,31.75,378.36,86.71,405.29s92.77-18.61,170.17-24.54,98.14,3.71,162.63-41.6S496.27,193.69,446.1,122.5,333.11,35.89,333.11,35.89Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.11,35.89S259.66,14.26,187.13,58,77.62,183.33,45.89,248.78,31.75,378.36,86.71,405.29s92.77-18.61,170.17-24.54,98.14,3.71,162.63-41.6S496.27,193.69,446.1,122.5,333.11,35.89,333.11,35.89Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Menu--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.96,
    y: 224.66,
    width: 401.66,
    height: 18.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 103,
    width: 413,
    height: 133,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.36,103v66.63h-10.3c-13,1.37-20.59-8.92-17.84-24.71s-41.87,8.93-52.16,0c-7.29-6.31,18.43-29.12,34.08-41.92Zm202.81,36.1c7.61,18,88.15-32.1,70.2-3.26s-36.46,48.43,3.81,39.73l1.82-.43V103H423.79C405.52,112.53,381.32,127.68,386.17,139.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,103v66.63h-10.3c-13,1.37-20.59-8.92-17.84-24.71s-41.87,8.93-52.16,0c-7.29-6.31,18.43-29.12,34.08-41.92Zm202.81,36.1c7.61,18,88.15-32.1,70.2-3.26s-36.46,48.43,3.81,39.73l1.82-.43V103H423.79C405.52,112.53,381.32,127.68,386.17,139.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 103,
    width: 413,
    height: 133,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.1,
    y: 103,
    width: 144.79,
    height: 133,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.58,174c-15.87,8.48-61.7,45.49-81.86,62H327.9V104.64c-17,6.92-81.79,33.94-85.36,44.36C238.42,161,300.16,163,279.58,174Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,174c-15.87,8.48-61.7,45.49-81.86,62H327.9V104.64c-17,6.92-81.79,33.94-85.36,44.36C238.42,161,300.16,163,279.58,174Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183.1,
    y: 103,
    width: 144.79,
    height: 133,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.44,153.61c4.29,9.42,16.35,16.64,22.16,18.39,0,0,15.56,5.44,27.23-3.58s14.24-26.52,3.23-43.56-34.53-13.37-44.61-3.78S333.16,144.19,337.44,153.61ZM370,138c3.79,3.3,4,8,.25,10.27a6.74,6.74,0,0,1-6.9-.12,5.35,5.35,0,0,1-2.35-6.84C362.1,138.63,366.24,134.69,370,138Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,122.41c-1.46,4.67-2.17,6-4.58,8.3s-3.69,6.13-3.4,8.15a36.77,36.77,0,0,1,.32,7.24,10.67,10.67,0,0,0,4,8.68,21.85,21.85,0,0,1,5.41,5.69c2.11,2.91,1.42,3.57,4.58,5.16s9.13,4.77,9.13,4.77,6.82,3,9.88,1.76,6.7-5.71,9.08-6.66,3.49,1.6,6.64-3,4.07-8.14,6-9.95,2.39-8.18-.23-10.93a14.06,14.06,0,0,1-4.3-9.7c-.39-4.55-1.67-7.28-6.5-8.91s-8.44-5.76-10.25-7.32-6.7-1.18-9.77.42-5.86-1-9.09.45c-1,.46-2,.75-2.79,1.08a27.29,27.29,0,0,0-2.48,1.64A8.62,8.62,0,0,0,346,122.41ZM361.42,139c2,.38,3.11-3.29,6.64-3.37s1.47,1.89,2,2.4a9.61,9.61,0,0,1,2.06,2.49,6,6,0,0,1,1.18,2.64,7.35,7.35,0,0,0,1.4,4.58c1.13,1.54-1.39,1.65-3.59,2.1s-2.36.27-4.08,1.57-4.18-.94-4.18-.94-1.5-.54-2.95-3.1.08-3-1.22-5.08S359.41,138.56,361.42,139Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.36,
    cy: 124.93,
    r: 1.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.91,
    cy: 129.16,
    r: 0.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.26,
    cy: 120.57,
    r: 1.12,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.91,137.87a2,2,0,1,1-2-2A2,2,0,0,1,350.91,137.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.06,131.53a1.37,1.37,0,1,1-1.37-1.37A1.36,1.36,0,0,1,374.06,131.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.69,
    cy: 123.31,
    r: 1.12,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,132.77a1.62,1.62,0,1,1-1.62-1.62A1.63,1.63,0,0,1,384,132.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,146.46a1.37,1.37,0,1,1-1.37-1.37A1.37,1.37,0,0,1,386,146.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,160.52a1.5,1.5,0,1,1-1.5-1.49A1.5,1.5,0,0,1,377.55,160.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.12,
    cy: 162.76,
    r: 2.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.78,
    cy: 149.2,
    r: 1.12,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.86,154.8a1,1,0,1,1-1-1A1,1,0,0,1,363.86,154.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.19,144a.87.87,0,1,1-.87-.87A.87.87,0,0,1,344.19,144Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.16,121.45a.75.75,0,1,1-.75-.75A.74.74,0,0,1,351.16,121.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.37,131.53a.62.62,0,0,1-.62.62.63.63,0,0,1,0-1.25A.63.63,0,0,1,360.37,131.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.54,140.24a.87.87,0,1,1-.87-.87A.87.87,0,0,1,378.54,140.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.76,154.3a1.5,1.5,0,1,1-1.5-1.49A1.49,1.49,0,0,1,386.76,154.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,142a1.37,1.37,0,1,1-1.36-1.37A1.36,1.36,0,0,1,357.13,142Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.91,154.3a1,1,0,1,1-1-1A1,1,0,0,1,350.91,154.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.44,135.63a1.25,1.25,0,1,1-1.25-1.24A1.25,1.25,0,0,1,345.44,135.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.84,119.7a.75.75,0,1,1-.75-.74A.75.75,0,0,1,367.84,119.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,150.85h0a2.13,2.13,0,0,1-1.8-1.4A18.42,18.42,0,0,0,79,146.6a2.12,2.12,0,0,1-2,1.08l-2.31-.2a2.11,2.11,0,0,0-2.1,3l4.13,9.21c.33.75.66,1.5.94,2.27a18.42,18.42,0,0,0,34.63.21c.64-1.75,1.32-3.5,2.11-5.19l1.45-3.1A2.1,2.1,0,0,0,114.13,150.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,150.85h0a2.13,2.13,0,0,1-1.8-1.4,18.26,18.26,0,0,0-1.81-3.65L107,154.68a218,218,0,0,1-18.79,18.19A18.42,18.42,0,0,0,95,174.16l.78,0a129.85,129.85,0,0,0,16.71-12.59c.59-1.56,1.19-3.11,1.9-4.61l1.45-3.1A2.1,2.1,0,0,0,114.13,150.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.02,
    cy: 136.43,
    r: 27.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.02,
    cy: 136.43,
    r: 23.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.02,
    cy: 136.43,
    r: 18.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,123.59v0l-22.51-11.4L59,117.76l21.3,11.1a3.09,3.09,0,0,0,1.74.54,3,3,0,0,0,1.25-5.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.07,114.72a3,3,0,1,1-3-3A3,3,0,0,1,62.07,114.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 119.83,
    x2: 266,
    y2: 119.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 119.83,
    x2: 308.05,
    y2: 119.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 130.08,
    x2: 266,
    y2: 130.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 130.08,
    x2: 308.05,
    y2: 130.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 140.34,
    x2: 266,
    y2: 140.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 140.34,
    x2: 308.05,
    y2: 140.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 150.6,
    x2: 266,
    y2: 150.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 150.6,
    x2: 308.05,
    y2: 150.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 160.86,
    x2: 266,
    y2: 160.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 160.86,
    x2: 308.05,
    y2: 160.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 181.88,
    x2: 266,
    y2: 181.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 181.88,
    x2: 308.05,
    y2: 181.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 192.14,
    x2: 266,
    y2: 192.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 192.14,
    x2: 308.05,
    y2: 192.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 202.4,
    x2: 266,
    y2: 202.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 202.4,
    x2: 308.05,
    y2: 202.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 212.66,
    x2: 266,
    y2: 212.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 212.66,
    x2: 308.05,
    y2: 212.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.99,
    y1: 222.91,
    x2: 266,
    y2: 222.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.92,
    y1: 222.91,
    x2: 308.05,
    y2: 222.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.44,
    y1: 181.88,
    x2: 403.45,
    y2: 181.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.37,
    y1: 181.88,
    x2: 445.5,
    y2: 181.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.44,
    y1: 192.14,
    x2: 403.45,
    y2: 192.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.37,
    y1: 192.14,
    x2: 445.5,
    y2: 192.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.44,
    y1: 202.4,
    x2: 403.45,
    y2: 202.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.37,
    y1: 202.4,
    x2: 445.5,
    y2: 202.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.44,
    y1: 212.66,
    x2: 403.45,
    y2: 212.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.37,
    y1: 212.66,
    x2: 445.5,
    y2: 212.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.44,
    y1: 222.91,
    x2: 403.45,
    y2: 222.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.37,
    y1: 222.91,
    x2: 445.5,
    y2: 222.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.9,
    y1: 182.91,
    x2: 122.9,
    y2: 182.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.83,
    y1: 182.91,
    x2: 164.96,
    y2: 182.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.9,
    y1: 193.17,
    x2: 122.9,
    y2: 193.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.83,
    y1: 193.17,
    x2: 164.96,
    y2: 193.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.9,
    y1: 203.43,
    x2: 122.9,
    y2: 203.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.83,
    y1: 203.43,
    x2: 164.96,
    y2: 203.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.9,
    y1: 213.68,
    x2: 122.9,
    y2: 213.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.83,
    y1: 213.68,
    x2: 164.96,
    y2: 213.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.9,
    y1: 223.94,
    x2: 122.9,
    y2: 223.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.83,
    y1: 223.94,
    x2: 164.96,
    y2: 223.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.4,279s0-3.85-5.38-9.23-8.85-8.46-8.85-8.46-2.69,8.85,2.31,14.23a94.89,94.89,0,0,0,11.92,10.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.59,303s0-3.84-5.39-9.22-8.84-8.46-8.84-8.46-2.69,8.84,2.31,14.22a94,94,0,0,0,11.92,10.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06,285.53s.4-3.82,6.32-8.6,9.69-7.48,9.69-7.48,1.74,9.08-3.8,13.9a94,94,0,0,1-12.94,9.07Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.62,313.89s.81-3.76,7.2-7.9,10.42-6.41,10.42-6.41S109,308.78,103,313a93.68,93.68,0,0,1-13.83,7.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,344.8s0-3.85,5.38-9.23,8.84-8.45,8.84-8.45,2.69,8.84-2.31,14.22A94.38,94.38,0,0,1,92.4,351.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.31,352.34s.54-3.8-4-9.89-7.55-9.63-7.55-9.63-3.92,8.37.26,14.4a94.33,94.33,0,0,0,10.32,12Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,374.7s0-3.84,5.38-9.22,8.84-8.46,8.84-8.46,2.69,8.84-2.3,14.22A94,94,0,0,1,87,381.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59,395s-1-3.72,2.87-10.29,6.41-10.42,6.41-10.42,4.85,7.87,1.38,14.34-9.88,11.54-9.88,11.54Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,278a109.15,109.15,0,0,1-1.47,11.94c-2.13,11-7.45,18.08-9.57,28s4,22.71,2.34,35.47-6.6,19.84-5.18,28.35S94,417,94,417",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.01,
    y1: 288.09,
    x2: 105.8,
    y2: 283.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.27,
    y1: 282.96,
    x2: 97.85,
    y2: 278.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.16,317.49s4.85-3.64,9.85-7.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.59,309.91A77.76,77.76,0,0,0,84,296.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.59,350.27A60,60,0,0,1,103,336.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,355.66a67,67,0,0,0-5.26-10c-2.83-4.18-3.23-4.72-3.23-4.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,381.77a65.79,65.79,0,0,1,4.37-8.85A56.32,56.32,0,0,1,97,365.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,402.56a35.64,35.64,0,0,1,2.83-9.4c2-3.92,4.32-9,5.26-11.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.48,330.34s-.42-2.41,2.37-6.37,4.63-6.26,4.63-6.26,2.65,5.25.1,9.17a59.77,59.77,0,0,1-6.35,7.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,344.55s-.41-2.41,2.38-6.37S71,331.91,71,331.91s2.65,5.26.1,9.17a60.23,60.23,0,0,1-6.35,7.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,334.41s-.67-2.35-4.9-4.71-6.88-3.64-6.88-3.64-.11,5.88,3.89,8.31a60.46,60.46,0,0,0,9.1,4.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4,351.16S65.48,348.89,61,347s-7.23-2.9-7.23-2.9.51,5.86,4.74,7.85a60.43,60.43,0,0,0,9.5,3.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.64,370.74s-.42-2.41-4.38-5.2-6.46-4.34-6.46-4.34-.73,5.83,3,8.66a59.76,59.76,0,0,0,8.6,5.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52,375.46s-.76-2.32,1.44-6.64S74.65,362,74.65,362s3.37,4.83,1.4,9.07a60.4,60.4,0,0,1-5.17,8.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.27,394.91s.28-2.43,4.07-5.45,6.21-4.7,6.21-4.7,1.06,5.78-2.49,8.82a60.25,60.25,0,0,1-8.29,5.7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.27,388.91s-.42-2.41-4.38-5.2-6.46-4.35-6.46-4.35-.73,5.84,3,8.67a60.82,60.82,0,0,0,8.6,5.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.22,402s.2-2.44-2.92-6.14S67.15,390,67.15,390s-2.18,5.46.7,9.15a60.18,60.18,0,0,0,7,7.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.07,329.78a67.43,67.43,0,0,0,2.22,7.32c2.52,6.66,6.63,10.53,9,16.53s0,14.67,2.38,22.49S76,387.85,76,393.34,73.49,415,73.49,415",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.71,
    y1: 336.01,
    x2: 53.59,
    y2: 333.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.99,
    y1: 332.82,
    x2: 58.04,
    y2: 329.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,353.37s-3.44-1.75-7-3.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.73,348.89a49.39,49.39,0,0,1,4-9.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11,374.19a38.11,38.11,0,0,0-8-7.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.29,377.47a43.78,43.78,0,0,1,2.22-6.83c1.32-2.93,1.51-3.31,1.51-3.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,397.5a36.54,36.54,0,0,1,4.43-4.6,23.62,23.62,0,0,0,2.88-2.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,393.34a41.87,41.87,0,0,0-3.7-5.07,36.29,36.29,0,0,0-4.36-4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,406.4A10.53,10.53,0,0,0,73,401.22c-1.69-2.24-3.69-5.2-4.5-6.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.19,160s27.6,26.67,28.84,40-19.23,24.19-13.33,28.53,22,15.82,15.81,25.74-9.3,12.41-7.13,14.58,7.44,4,7.13,9.3S288,288,288,288H190s-5.27.31-4.65-7.13,11.16-11.47,9.3-17.06-15.51-9.92-15.51-21.09,16.13-15.81,18.61-21.08-8.06-8.69-10.23-15.51,9-18.61,15.81-24.81,34.12-24.19,45-24.81S263.19,160,263.19,160Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.59,167.22s15,26.21,12.63,36.5-18.25,22-12.17,29.95,15,11.23,11.24,21.06a49.38,49.38,0,0,1-9.83,15.91",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.67,203.26s9.36,14.5,7,18.71-15.91,9.36-14,20.12,21.53,27.61,21.53,29.49",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.19,160s27.6,26.67,28.84,40-19.23,24.19-13.33,28.53,22,15.82,15.81,25.74-9.3,12.41-7.13,14.58,7.44,4,7.13,9.3S288,288,288,288H190s-5.27.31-4.65-7.13,11.16-11.47,9.3-17.06-15.51-9.92-15.51-21.09,16.13-15.81,18.61-21.08-8.06-8.69-10.23-15.51,9-18.61,15.81-24.81,34.12-24.19,45-24.81S263.19,160,263.19,160Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62,273.27s37.5,58.5,43,65.5-.5,18.5-9,24.5-22.73.76-30.11-6.87-14.89-25.63-14.89-25.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.62,253.77s-35,10.5-46,14.5-14,4.5-14,8.5c0,2.33,8.35,47.64,7.5,86.5-.61,28.08-10.5,53.5-10.5,53.5h127.5s-10.46-23.85-10.5-52.5c-.06-40.15,10.17-89.24,9-91C296.62,270.27,240.12,253.27,235.62,253.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,373.71c-4.58-3.57-10.53-9.44-13.38-17.44-4.43-12.41-7.69-79-8.37-94-2.37-.72-4.75-1.44-7.09-2.13l1,62.63h-44.5l-3.89-62.31c-2.37.73-4.76,1.48-7.1,2.22.05,12.65.05,71.66-3.51,88.59-2.73,13-14.1,21.77-21,26a181.75,181.75,0,0,1-9.47,39.47h127.5A147.14,147.14,0,0,1,290,373.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.09,262.22l-1.46.46c.05,12.65.05,71.66-3.51,88.59-.2.94-.45,1.84-.73,2.73v62.77h5.7Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.44,
    y: 322.77,
    width: 5.7,
    height: 94,
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.34,397.72v19H184V376c-.68.45-1.34.88-1.95,1.26A178.58,178.58,0,0,1,178.34,397.72Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,365.38a48.57,48.57,0,0,1-5.69,5.84v45.55h5.69Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.41 271.47 214.41 416.77 220.11 416.77 220.11 322.77 217.62 322.77 214.41 271.47",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53,346.17v70.6h5.69v-53.4a32.86,32.86,0,0,1-3.6-7.1A60.06,60.06,0,0,1,274.53,346.17Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,370.76v46h5.7V390A141.55,141.55,0,0,1,290,373.71C288.91,372.86,287.74,371.87,286.55,370.76Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2,262.26c-1.9-.59-3.81-1.16-5.69-1.72V416.77h5.69Z",
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.48,
    y: 322.77,
    width: 5.7,
    height: 94,
    style: {
      fill: "#424242"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.46,
    y: 322.77,
    width: 5.7,
    height: 94,
    style: {
      fill: "#424242"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290,373.71c-4.58-3.57-10.53-9.44-13.38-17.44-4.43-12.41-7.69-79-8.37-94-2.37-.72-4.75-1.44-7.09-2.13l1,62.63h-44.5l-3.89-62.31c-2.37.73-4.76,1.48-7.1,2.22.05,12.65.05,71.66-3.51,88.59-2.73,13-14.1,21.77-21,26a181.75,181.75,0,0,1-9.47,39.47h127.5A147.14,147.14,0,0,1,290,373.71Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.56,244.62s-13,4.65-15.51,9.92-1.24,26-3.41,32.25S205.2,297.65,208,298s11.16-12.41,15.5-10.86,16.13,17.68,17.06,17.68,9.93-10.85,11.79-14.26,8.68,1.86,11.78,9.61,4,5,4,2.17-3.72-14.89-3.1-17.06-.31-13-.31-23.88a18,18,0,0,0-14.89-18C243,242.13,231.56,244.62,231.56,244.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.66,236.86v35.05s11.48,37.83,15.51,35,13.34-33.49,13.34-33.49V237.17S240.24,243.38,225.66,236.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.66,236.86v7.29c5.8,3.33,12.63,5.58,18.78,5.58a22.74,22.74,0,0,0,10.07-2.49V237.17S240.24,243.38,225.66,236.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.88,198.72s-6.82-9-10.86-2.49,6.52,18.61,9.62,18.3S213.88,198.72,213.88,198.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,198.72s6.82-9,10.86-2.49-6.52,18.61-9.62,18.3S268.73,198.72,268.73,198.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,186.12s-3.44,31-.43,40,18.93,18.93,31.84,18.93,23.65-12.47,25.38-19.79-2.16-54.2-4.74-59.36-18.92-5.59-35.27,2.58S213,186.12,213,186.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2,191s-2.79,7.45-.31,11.79.93,7.44-1.86,7.44-4-4.65-4-4.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,213.29s13,9,24.5,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,186.62s5.59-6.2,12.1.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,186s-5.58-5.89-12.41-.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.27,
    cy: 195.92,
    rx: 1.86,
    ry: 3.72,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.01,
    cy: 195.92,
    rx: 1.86,
    ry: 3.72,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,201.2a29.57,29.57,0,0,1,9.62,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.65,201.51a25.65,25.65,0,0,1,9.3,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,204s48.69-20.16,60.48-29.47,14.88-27.29-12.72-26.36-56.75,33.19-59.23,48.07S194,208,194,208",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.5,149a147.73,147.73,0,0,1-40.24,34.16c-25.74,15-42.12,17.79-42.12,17.79",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.25,144.29s-22.93,36-65.51,50.07",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,204s48.69-20.16,60.48-29.47,14.88-27.29-12.72-26.36-56.75,33.19-59.23,48.07S194,208,194,208",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.62,315.52s-5.75-2.5-12.5-4.75-10.5,2.25-7.75,6.25,12.5,4.75,17.25,9,8.5,18,13.25,20.5a30.49,30.49,0,0,0,10,3v-34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.03 356.4 302.51 356.4 296.13 297.57 337.41 297.57 331.03 356.4",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.39 288.35 295.14 288.35 291.37 296.27 342.62 296.27 338.39 288.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.75 298.83 337.68 298.83 341.25 296.27 292.75 296.27 296.75 298.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.78 340.27 336.44 306.52 297.1 306.52 300.76 340.27 332.78 340.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.12,316.77s-13.25.25-15.75,2.75-1.75,5.5,3,6,11.75,1.5,15.5.5S348.62,316.77,342.12,316.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,343.52s-10.52.2-12.5,2.19-1.39,4.36,2.38,4.76,9.32,1.19,12.3.39S344.23,343.52,339.08,343.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.62,327s-17.25,0-21.5.75-5.75,5,.5,6.25,19,2,23,1.5S350.87,326.77,344.62,327Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.62,336s-13.75-.5-18.5,1.25-3,4.25,1.5,5.25,14.5,2.25,18.25,1S348.62,335.52,343.62,336Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,247.78s-2.65,1.59-.79,9.55l1.85,7.95,11.4-2.12s-5-9-7.16-13S131.57,246.72,131,247.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,262.37s36.32-6.1,47.2-9.81a244.92,244.92,0,0,1,24.92-6.63,31.27,31.27,0,0,1,6.63-.8s1.06,0,.8,4.51,5.83,63.11,11.4,81.14,9,26.52,9,26.52-32.61,6.63-62.84,6.63a273.48,273.48,0,0,1-49.85-4.25c-1.06,0,13-53,12.46-71.06C121.22,270.36,122,262.37,122,262.37Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,330.78c-5.57-18-11.67-76.63-11.4-81.14s-.8-4.51-.8-4.51a32,32,0,0,0-3.72.27,14.13,14.13,0,0,0,0,3.44S196.8,277.75,196,312c-.66,28.38-.23,44.7-.06,49.44,15.09-1.87,26-4.09,26-4.09S218.55,348.81,213,330.78Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.25,246.46v13.26c0,4.24.8,6.36-.8,6.36s-14.84,2.39-36.32,6.63a300.05,300.05,0,0,1-41.37,5.3c-1.59,0,.27-15.64.27-15.64s40.3-6.37,53.29-10.61a191.74,191.74,0,0,1,23.6-6.1",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.85,236.91s2.65-6.1,9.81-2.12,11.93,18.3,10.87,21.21-4.51,3.72-7.43.8-10.34-13.52-12.19-16.44S153.85,236.91,153.85,236.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,240.62s13.4,19.54,15.91,21.22,7.18,2.64,5.83-3.18c-1.27-5.53-6.36-16.18-9.81-19.89s-5.83-4.24-8.75-2.65S145.36,238.5,145.89,240.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,239.56s12.46,15.91,13.53,19.63-1.07,9.81-6.63,6.36-10.61-14.85-13.79-18.83S142.44,236.65,147,239.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.53,243.54s-8,1.06-9,5.3,5.83,13.53,11.4,15.12,7.16-2.92,5.57-6.63S142.18,244.34,139.53,243.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.97 398.51 342.45 398.51 362.69 304.56 449.21 304.56 428.97 398.51",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.21,304.56H362.69S411.68,316.39,449.21,304.56Z",
    style: {
      fill: "#6b6b6b",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.42 345.11 381.3 373.16 396.85 383.64 402.93 366.07 390.42 345.11",
    style: {
      fill: "#3b3b3b",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.42 345.11 420.5 345.11 425.23 363.03 402.93 366.07 390.42 345.11",
    style: {
      fill: "#3b3b3b",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.09,414.39a134.45,134.45,0,0,0-18.56-58.8l-23.72,58.8Z",
    style: {
      fill: "#3b3b3b",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.41,414.39c.62-27.45-13.63-58.8-13.63-58.8H398.53a134.45,134.45,0,0,1,18.56,58.8Z",
    style: {
      fill: "#6b6b6b",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.69,
    y: 411.27,
    width: 425.62,
    height: 10.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/AboutUs.585b327403d2b1332f1b7b9c3e86ff55.svg";
export { ForwardRef as ReactComponent };